<div class="container mx-auto px-4 py-6" *transloco="let t">
  <div class="p-6 w-full max-w-7xl mx-auto bg-white shadow-md rounded-lg">
    <h2 class="text-2xl font-bold mb-4 text-gray-700">{{ isEditMode ? t('users.form.editProfile') : t('users.form.createProfile') }}</h2>

    <!-- Nome -->
    <div class="mb-6">
      <label for="name" class="block text-sm font-medium text-gray-700 mb-2">
        {{ t('users.form.name') }} {{ !isEditMode ? '*' : '' }}
      </label>
      <input
        type="text"
        id="name"
        [(ngModel)]="name"
        #nameInput="ngModel"
        [required]="!isEditMode"
        [minlength]="3"
        class="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        [placeholder]="t('users.form.namePlaceholder')">

      <div *ngIf="formSubmitted && nameInput.invalid && !isEditMode" class="text-red-600 text-sm mt-1">
        {{ t('users.form.nameRequired') }}
      </div>
      <div *ngIf="formSubmitted && name && name.trim().length < 3" class="text-red-600 text-sm mt-1">
        {{ t('users.form.nameMin') }}
      </div>
    </div>

    <!-- Descrição -->
    <div class="mb-6">
      <label for="description" class="block text-sm font-medium text-gray-700 mb-2">
        {{ t('users.form.description') }}
      </label>
      <textarea
        id="description"
        [(ngModel)]="description"
        rows="4"
        class="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        [placeholder]="t('users.form.descriptionPlaceholder')">
      </textarea>
    </div>

    <!-- Permissões -->
    <div class="mb-6">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ t('users.form.permissions') }} {{ !isEditMode ? '*' : '' }}
      </label>

      <div *ngIf="permissions.length === 0" class="text-gray-500 text-sm">
        {{ t('users.form.loadingPermissions') }}
      </div>

      <app-permission-tree
        *ngIf="permissions.length > 0"
        [permissions]="permissions"
        [selectedKeys]="selectedPermissionKeys"
        (selectedKeysChange)="onPermissionKeysChange($event)">
      </app-permission-tree>

      <div *ngIf="formSubmitted && (!selectedPermissionKeys || selectedPermissionKeys.length === 0)" class="text-red-600 text-sm mt-1">
        {{ t('users.form.selectAtLeastOnePermission') }}
      </div>
    </div>

    <!-- Status Ativo -->
    <div class="mb-6">
      <label class="flex items-center">
        <input
          type="checkbox"
          [(ngModel)]="isActive"
          class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
        <span class="ml-2 text-sm text-gray-700">{{ t('users.form.profileActive') }}</span>
      </label>
    </div>

    <!-- Botões de Ação -->
    <div class="mt-6 flex justify-end space-x-4">
      <button
        (click)="save()"
        class="w-32 h-10 bg-green-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">
        {{ t('common.save') }}
      </button>
      <button
        (click)="cancelar()"
        class="w-32 h-10 bg-gray-600 text-white rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
        {{ t('common.cancel') }}
      </button>
    </div>
  </div>
</div>
